import type { LegalLocations } from './legal';
import LegalLocationsImpl from './legalImpl';

export type { LegalLocations };
export default LegalLocationsImpl;
